import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const RET = '';
const ZObjectPositioning = ({windowRef, coords, isInstrumentView, presentationMode, zobject}) => { 
    useEffect(() => {
        if (coords) {
            windowRef.current.style.left = coords.x + 'px';
            windowRef.current.style.top = coords.y + 'px';
        }
    }, [coords]);
    return RET; 
}

const mapStateToProps = (state, props) => {
    let presentationMode = state.spatial.presentationMode || props.isInstrumentView;
    return {
        presentationMode,
        coords: presentationMode ?
            state.windows.presentationWindowPositions[props.zobject.id] || state.windows.windowPositions[props.zobject.id] :
            state.windows.windowPositions[props.zobject.id],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZObjectPositioning);
